export const newRow = {
    businessArea: '',
    userId: '',
    userName: '',
    vendorType: '',
    posId: '',
    imei: '',
    type: '',
    status: 'ACTIVE'
}

export const machineTypes = [
    { label: 'Android', value: 'Android' },
    { label: 'Normal', value: 'Normal' },
]

export const vendorTypes = [
    { label: 'PineLabs', value: 'PineLabs' },
    { label: 'Paytm', value: 'Paytm' },
    { label: 'AXIS Sound Box', value: 'AxisBankSoundBox' },
 ]